import React from 'react';
import PropTypes from 'prop-types';
import {
  Stepper,
  Step,
  StepLabel,
} from '@mui/material';
import {
  AccessTime,
  ErrorOutline,
  RadioButtonUnchecked,
  CheckCircleOutline,
} from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';
import { useIsMobile } from '../../hooks';
import { orderingStatusToStepLabels, orderingStatusToActiveStep, orderingStatusToLabel } from '../../helpers';

export const statusToIcon = {
  EVALUATION: <AccessTime color="warning" sx={{ fontSize: 20 }} />,
  REJECTED: <ErrorOutline color="error" sx={{ fontSize: 20 }} />,
  OFFERED: <CheckCircleOutline color="success" sx={{ fontSize: 20 }} />,
  PENDINGASSIGNMENTDOCUMENT: <AccessTime color="warning" sx={{ fontSize: 20 }} />,
  PENDINGSIGNATURE: <AccessTime color="warning" sx={{ fontSize: 20 }} />,
  PENDINGTRANSFER: <AccessTime color="warning" sx={{ fontSize: 20 }} />,
  PENDINGCOLLECTION: <AccessTime color="warning" sx={{ fontSize: 20 }} />,
  PENDINGINVOICES: <AccessTime color="warning" sx={{ fontSize: 20 }} />,
  FACTORING: <AccessTime color="warning" sx={{ fontSize: 20 }} />,
  FINISHED: <CheckCircleOutline color="success" sx={{ fontSize: 20 }} />,
};

const useStyles = makeStyles({
  stepper: {
    padding: 0,
    width: '90%',
    overflowX: 'hidden',
  },
  stepLabel: {
    marginTop: '4px !important',
    fontSize: 10,
  },
  collectionActionsButton: {
    fontSize: 12,
    height: 0,
  },
});

const getStatusIcon = (status, i) => {
  if (i < orderingStatusToActiveStep[status]) return <CheckCircleOutline color="success" sx={{ fontSize: 20 }} />;
  if (orderingStatusToActiveStep[status] === i) return statusToIcon[status];
  return <RadioButtonUnchecked sx={{ fontSize: 20 }} />;
};
const OrderingStatus = ({ status }) => {
  const isMobile = useIsMobile();
  const classes = useStyles();
  return (
    <Stepper
      className={classes.stepper}
      activeStep={orderingStatusToActiveStep[status]}
      alternativeLabel
    >
      {orderingStatusToStepLabels(orderingStatusToLabel[status]).map((label, i) => (
        ((isMobile && i === orderingStatusToActiveStep[status]) || !isMobile) && (
          <Step key={label}>
            <StepLabel
              icon={getStatusIcon(status, i)}
              classes={{
                label: classes.stepLabel,
              }}
            >
              {label} <br />
            </StepLabel>
          </Step>
        )))}
    </Stepper>
  );
};

OrderingStatus.propTypes = {
  status: PropTypes.string.isRequired,
};

export default OrderingStatus;
